import {NumberBox} from "devextreme-react";
import {useFormContext, useFormState} from "react-hook-form";

interface IProps {
    title?: string;
    fieldName: string;
    showBorder?: boolean;
    width?: number;
    required?: boolean;

    modelField?: string;
    index?: number;
    tableName?: string;
    tableFieldName?: string;
}

export const NFPlainNumber = ({
                                  title,
                                  fieldName,
                                  showBorder = true,
                                  width,
                                  modelField,
                                  index,
                                  tableName,
                                  tableFieldName,
                              }: IProps) => {
    const {getValues, watch} = useFormContext();

    const watchedFieldName = () => {
        if (tableFieldName && tableName) {
            return modelField ? `${tableName}[${index}].${modelField}` : `${tableName}[${index}].${tableFieldName}`;
        }
        return modelField ? modelField : fieldName;
    }

    const value = watch(watchedFieldName());

    const getValue = (): number => {
        if (modelField && value && tableFieldName) {
            return value[tableFieldName];
        }
        return value;
    }

    return (
        <div className={title ? "form-group" : ""}>
            {title && <label className={"form-label-sm"}>{title}</label>}
            <NumberBox
                value={getValue()}
                readOnly={true}
                width={width || undefined}
                className="bg-light"
                style={{border: showBorder === true ? "block" : "none"}}
            />
        </div>
    );
};
